// カテゴリー別の入力フォーム情報
export const questions = [
  {
    category_id: 1,
    input_entry_type: 1,
    category_name: '出会いについて',
    questions: ['lover_search_period', 'romance_history', 'entry_detail']
  },
  {
    category_id: 2,
    input_entry_type: 1,
    category_name: '結婚について',
    questions: ['love_status', 'lover_search_period', 'entry_detail']
  },
  {
    category_id: 3,
    input_entry_type: 1,
    category_name: '相性について',
    questions: ['entry_detail']
  },
  {
    category_id: 4,
    input_entry_type: 1,
    category_name: '仕事について',
    questions: ['entry_detail']
  },
  {
    category_id: 5,
    input_entry_type: 1,
    category_name: 'なんでもお悩み相談',
    questions: ['entry_genre', 'entry_detail']
  },
  {
    category_id: 6,
    input_entry_type: 0,
    category_name: 'おまかせ',
    questions: ['praise_detail']
  },
  {
    category_id: 6,
    input_entry_type: 3,
    category_name: 'おまかせ',
    questions: ['has_partner']
  },
  {
    category_id: 6,
    input_entry_type: 4,
    category_name: 'おまかせ',
    questions: ['partner_birthday']
  },
  {
    category_id: 6,
    input_entry_type: 5,
    category_name: 'おまかせ',
    questions: ['metal_name']
  },
  {
    category_id: 6,
    input_entry_type: 6,
    category_name: 'おまかせ',
    questions: ['neko_name', 'neko_theme']
  },
  {
    category_id: 6,
    input_entry_type: 7,
    category_name: 'おまかせ',
    questions: ['licorice_name']
  }
];

export const mapPlaceholder = category_id => {
  if (category_id <= 5) {
    const placeholders = {
      1: '例)まずはお付き合いできる素敵な男性と出会いたいです。アドバイスをお願いします。',
      2: '例)好きな人がいます。その人との結婚の可能性を教えてほしいです。',
      3: '例)彼氏との相性が聞きたいです。',
      4: '例)今後のスキルアップするには転職も含めてどうしたらいいかアドバイスがほしいです。',
      5: '選択されたテーマに沿った質問内容を１つだけ入力してください。'
    };
    return placeholders[category_id];
  }
  if (category_id == 6) {
    return '例：金運について／好きな人(1990年7月7日)と付き合えますか？';
  }
};

export default {
  questions,
  mapPlaceholder
};



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/EntryForm/data/categoryConfig.js